




















































































import { Component, Vue } from "vue-property-decorator"
import LayoutMain from "@/components/common/LayoutMain.vue"
import request from "@/utils/requests"

@Component({
	components:
	{
		LayoutMain
	}
})

export default class Contact extends Vue
{
	public name: string = ""
	public email: string = ""
	public phone: string = ""
	public message: string = ""
	public noteprevent: string = ""
	public showsuccess: boolean = false

	public sendContactInfo()
	{
		if (this.name === "")
		{
			alert("Indtast venligst dit navn")
			const field: HTMLInputElement = (this.$refs.name as HTMLInputElement)
			field.focus()
			return
		}

		if (this.email === "")
		{
			alert("Indtast venligst din email adresse")
			const field: HTMLInputElement = (this.$refs.email as HTMLInputElement)
			field.focus()
			return
		}

		if (this.message === "")
		{
			alert("Indtast venligst en besked")
			const field: HTMLInputElement = (this.$refs.message as HTMLInputElement)
			field.focus()
			return
		}

		if (this.noteprevent !== "")
		{
			return
		}

		const params: any = {
			name: this.name,
			email: this.email,
			phone: this.phone,
			message: this.message
		}

		request.post("/contact/sendinformation", params).then(data =>
		{
			const dataresult: String = data.toString()

			if (dataresult !== "ok")
			{
				alert("Der opstod en fejl ved afsendelse af beskeden. Prøv venligst igen.")
			}
			else
			{
				this.showsuccess = true
			}
		})
	}
}
